import React from 'react';
import classnames from 'classnames';
import Block from "./Block.js";
import S from './Row.css';

/**
 * react class to render a ghant chart row
 * @property {function} onRollover - rollover functionality
 * @property {function} onClick - onClick functionality
 * @property {any} rowData - added to the rollover and click function callbacks
 * @property {string} className - class to be applied to the element
 * @property {object} style - css properties to be applied to the element
 * @property {function} blockAccess - accessor to get block data from row data
 * @property {function} startAccess - accessor to get the start time from the data
 * @property {function} stopAccess - accessor to get the stop time from the data
 * @property {function} blockStylizer - calculates the style for the block
 * @property {string} blockClass - class to be applied to the blocks
 * @property {Projection} projection instance of the projection class
 */
import { jsx as _jsx } from "react/jsx-runtime";
class Row extends React.Component {
  onRollover = event => {
    const {
      onRollover,
      rowData
    } = this.props;
    if (onRollover) {
      onRollover({
        ...event,
        row: this,
        rowData
      });
    }
  };
  onClick = event => {
    const {
      onClick,
      rowData
    } = this.props;
    if (onClick) {
      onClick({
        ...event,
        row: this,
        rowData
      });
    }
  };
  toBlock(item, index) {
    const {
      projection,
      startAccess,
      stopAccess,
      blockStylizer,
      blockClass,
      blockComponent,
      blockProps,
      reverse = false
    } = this.props;
    const start = startAccess(item);
    const stop = stopAccess(item);
    const range = projection.rangeInPixels();
    const x1 = projection.startToScreen(start);
    const x2 = projection.stopToScreen(stop);
    const bc = typeof blockClass === 'function' ? blockClass(item, projection, start, stop) : blockClass;
    const style = blockStylizer && blockStylizer(item, projection, start, stop, x1, x2) || {};
    return /*#__PURE__*/_jsx(Block, {
      blockComponent: style.component || blockComponent || 'div',
      componentProps: {
        ...blockProps,
        ...style.componentProps
      },
      className: classnames(style.className, bc),
      style: style.style,
      startValue: start,
      stopValue: stop,
      x1: reverse ? range - x2 : x1,
      x2: reverse ? range - x1 : x2,
      data: item,
      projection: projection,
      onClick: this.onClick,
      onRollover: this.onRollover,
      children: style.children
    }, `block-${index}`);
  }
  render() {
    const {
      className,
      children,
      blockAccess,
      rowData,
      projection,
      rowComponent,
      rowProps
    } = this.props;
    // If blockAccess is not defined, assume rowData is an array
    const blocks = blockAccess == null ? rowData : blockAccess(rowData);
    const br = blocks.map((item, index) => this.toBlock(item, index));
    let rp = {};
    if (typeof rowProps === 'function') {
      rp = rowProps(rowData);
    } else {
      rp = {
        ...rowProps
      };
    }
    const {
      className: rcn,
      ...withoutClassName
    } = rp;
    return /*#__PURE__*/React.createElement(rowComponent || 'div', {
      ...withoutClassName,
      className: classnames(S.row, className, rcn),
      style: {
        width: `${projection.rangeInPixels()}px`
      }
    }, [...(children || []), ...(br || [])]);
  }
}
export default Row;